export default "__VITE_ASSET__f2879877__"